import axios, { AxiosResponse } from 'axios';

export const url = '/services/isnaportalsync/open-api/find-from-foreign-source';

export const getFromForeignSource = (request) => {
    return axios.get(`${url}`, { params: request, headers: {} });
};

export const downloadExcel = (request: any): Promise<AxiosResponse> => {
    return axios.get(`${url}-export`, {
        params: { ...request, excel: true },
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
    });
};
